export default __webpack_public_path__ + "locales/hy-AM/DowngradePlanDialog.json?hash=5df0459932b94d553ff9c3293ee4f594";